import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { getImage } from "gatsby-plugin-image"
import { convertToBgImage } from "gbimage-bridge"
import parse from 'html-react-parser'
import { FiChevronRight } from "react-icons/fi";
import Heading from '../../../components/shared/heading'
import Button from '../../../components/shared/button'
import { CtaWrap, CtaBG, CtaContent } from './cta.stc'

const CTA = ({ ctaHeading, ctaBtn }) => {
	const ctadataquery = useStaticQuery(graphql`
        query WidgetCtaQuery {
            file(relativePath: {eq: "images/cta-small-image.jpg"}) {
				childImageSharp {
					gatsbyImageData(width: 400, height: 480, layout: CONSTRAINED, quality: 100, placeholder: TRACED_SVG)
				}
            }
            cta: homeJson(jsonId: {eq: "home-cta-content"}) {
                title
                path
            }
        }
    `)
	const image = ctadataquery.file
	const imageData = getImage(image)
	const bgImage = convertToBgImage(imageData)
	const { cta } = ctadataquery;
	return (
		<CtaWrap>
			<CtaBG {...bgImage} />
			<CtaContent>
				{cta.title && <Heading {...ctaHeading} className="cta-heading">{parse(cta.title)}</Heading>}
				{cta.path && <Button {...ctaBtn} to={cta.path} icon={<FiChevronRight />}>Connect With me</Button>}
			</CtaContent>
		</CtaWrap>
	)
}

CTA.defaultProps = {
	ctaHeading: {
		as: 'h3',
		color: '#fff',
		fontSize: '24px',
		lineHeight: 1,
		letterSpacing: '3px',
		fontWeight: 300,
		mb: '30px'
	},
	ctaBtn: {
		colors: "light",
		fontWeight: 500,
		shape: 'rounded',
		pl: '25px',
		pr: '25px'
	}
}

export default CTA
